import React, { useContext } from 'react'
// import GetloanFields from './GetloanFields'
import SimpleInputField from '../../Custom/CustomInput/SimpleInputField'
import SimpleDateField from '../../Custom/CustomInput/SimpleDateField'
import { validateInputField } from '../../Utility/Utility.js'
import SearchFieldsContext from '../context/context'
import InputSelect from '../../Custom/CustomInput/InputSelect'
import InputRadioSelect from '../../Custom/CustomInput/InputRadioSelect'


export function LoanFilter() {
  const { searchFields, setSearchFields } = useContext(SearchFieldsContext)
  // const [timeSelection, setTimeSelection] = useState('daterange')
  function handleChange(e) {
    const { id, value, placeholder } = e.target
    const i = searchFields.loanFields.findIndex(x => x.propId === e.target.getAttribute('data-propid'))
    const newSearchFields = searchFields
    const requiriedValidation = ['currency', 'percent', 'text', 'number']
    const { type } = newSearchFields.loanFields[i]
    const maxInputValue = newSearchFields.loanFields[i].maxInputValue ? newSearchFields.loanFields[i].maxInputValue : ''

    const newValue = (requiriedValidation.indexOf(type) === -1) ? value : validateInputField(value, type, maxInputValue)
    if (type && requiriedValidation.indexOf(type) !== -1) {
      newSearchFields.loanFields[i] = (id.indexOf('min') !== -1 || placeholder === '') ? { ...newSearchFields.loanFields[i], minValue: newValue } : { ...newSearchFields.loanFields[i], maxValue: newValue }
    } else if (type !== undefined) {
      newSearchFields.loanFields[i] = (id.indexOf('start') !== -1) ? { ...newSearchFields.loanFields[i], startValue: newValue } : { ...newSearchFields.loanFields[i], endValue: newValue }
    } else {
      newSearchFields.loanFields[i] = { ...newSearchFields.loanFields[i], value: newValue }
    }
    setSearchFields({ ...newSearchFields })
  }
  function handleRadioChange(params) {
    if (params && params.model.groupName && params.model.groupName === 'timeRange') {
      const selectedItem = params.model.groupList.filter(sel => {
        return sel.selected
      })
      searchFields.loanFields.forEach(filter => {
        filter.isVisible = true
        if (selectedItem[0].key === 'timerange' && filter.propId === 'maturityDate') {
          filter.isVisible = false
          filter.startValue = ''
          filter.endValue = ''
        }
        if (selectedItem[0].key === 'daterange' && filter.propId === 'timeRange') {
          filter.isVisible = false
          filter.minValue = ''
          filter.maxValue = ''
        }
      })
    }
    const newSearchFields = { ...searchFields }
    newSearchFields.loanFields[params.index] = { ...newSearchFields.loanFields[params.index], ...params.model }
    setSearchFields({ ...newSearchFields })
  }

  return (
    <>
      <div className="flex flex-col gap-2">
        {searchFields ?
          searchFields.loanFields.map((value, index) => {
            const onchangeEvent = model => handleRadioChange({ model, index })

            return (
              value.isVisible ? (value.optionsList ? <>
                {value.label !== undefined ? <div className="text-2">
                  <label>{value.label}</label>
                </div> : null}
                <div className="mb-3">
                  <div className="flex flex-row space-x-2 sm:space-x-4">
                    <InputSelect propid={value.propId} optionsList={value.optionsList} testid={`Select-${value.fieldName}`} onChange={handleChange} id={value.proId} value={value.value} classes={value.isMinMax ? '' : 'w-full'}></InputSelect>
                  </div>
                </div>
              </> :
                <>
                  {value.label !== undefined ? <div className="text-2">
                    <label>{value.label}</label>
                  </div> : null}
                  <div className="mb-3">
                    <div className="flex flex-row space-x-2 sm:space-x-4">
                      {value.type === 'radio' ?
                        <InputRadioSelect propid={value.propId} onChange={onchangeEvent} groupList={value.groupList} type={value.type} groupName={value.groupName} />
                        :
                        (value.type === 'date' ?
                          <>
                            <SimpleDateField propid={value.propId} testid={`Start-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isStartEnd ? 'MM/DD/YYY' : ''} id={`start${value.propId}`} value={value.startValue} classes={value.isStartEnd ? '' : 'w-full'}></SimpleDateField>
                            {value.isStartEnd ?
                              <SimpleDateField propid={value.propId} testid={`End-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isStartEnd ? 'MM/DD/YYYY' : ''} id={`end${value.propId}`} value={value.endValue} ></SimpleDateField>
                              : null
                            } </>
                          :
                          <>
                            <SimpleInputField propid={value.propId} testid={`Min-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isMinMax ? 'Min' : ''} id={`min${value.propId}`} value={value.minValue} classes={value.isMinMax ? '' : 'w-full'}></SimpleInputField>
                            {value.isMinMax ?
                              <SimpleInputField propid={value.propId} testid={`Max-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isMinMax ? 'Max' : ''} id={`max${value.propId}`} value={value.maxValue} ></SimpleInputField>
                              : null
                            }</>
                        )}
                    </div>
                  </div>
                </>) : null
            )
          }) : null}
      </div>
    </>
  )
}
export default LoanFilter
